import { isPublicSpace, isSpaceMember } from "@/react/helpers/spaceHelpers";
import { usePunditUserContext } from "@circle-react/contexts";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import { BannerActions } from "./BannerActions";
import { BannerContent } from "./BannerContent";
import { BannerMedia } from "./BannerMedia";

export const Banner = ({ space, refetchSpace }: any) => {
  const { currentCommunityMember } = usePunditUserContext();
  const isLoggedIn = !!currentCommunityMember;

  const {
    logged_in_space_welcome_banner: loggedInSpaceWelcomeBanner,
    logged_out_space_welcome_banner: loggedOutSpaceWelcomeBanner,
    display_space_welcome_banner: displaySpaceWelcomeBanner,
  } = space || {};

  const isMember = isSpaceMember(space);
  const shouldDisplayBanner = isMember ? displaySpaceWelcomeBanner : true;
  const isPublicSpaceType = isPublicSpace(space || {});
  const welcomeBanner =
    isLoggedIn && isMember
      ? loggedInSpaceWelcomeBanner
      : isPublicSpaceType && loggedOutSpaceWelcomeBanner;

  const {
    banner_enabled: bannerEnabled,
    title,
    description,
    cover_url: coverUrl,
    allow_close: allowClose,
    is_video: isVideo,
  } = welcomeBanner || {};

  if (!(bannerEnabled && shouldDisplayBanner)) {
    return null;
  }

  const isAdmin = isCommunityAdmin(currentCommunityMember);

  return (
    <div className="relative mx-auto my-6 max-w-2xl p-0 md:mt-0">
      <BannerActions
        isAdmin={isAdmin}
        allowClose={allowClose}
        spaceId={space?.id}
        coverUrl={coverUrl}
        refetchSpace={refetchSpace}
      />
      {coverUrl && (
        <BannerMedia
          mediaURL={coverUrl}
          isVideo={isVideo}
          hasContent={Boolean(title || description)}
        />
      )}
      {(title || description) && (
        <BannerContent
          title={title}
          description={description}
          hasMedia={Boolean(coverUrl)}
        />
      )}
    </div>
  );
};
